import { isError } from "./is-error.js";
import { isObject } from "./is-object.js";

export const stringifyArgs = ({ args }) =>
  args.map((arg) => {
    if (isObject(arg)) {
      if (isError(arg)) {
        return arg.stack ?? String(arg);
      }

      try {
        return JSON.stringify(arg);
      } catch {
        return "[unserializable object]";
      }
    }

    return arg;
  });
